import dayjs from 'dayjs';

export const ICR_CLASSIFICATIONS = ['UNCLASSIFIED', 'SECRET', 'TOP SECRET'];

/** Show ICR classification as UNCLASSIFIED, SECRET, or TOP SECRET (no abbreviation). */
export function formatIcrClassification(classification) {
    if (classification == null || classification === '') {
        return '—';
    }
    const value = String(classification).trim();
    const upper = value.toUpperCase();
    if (upper.startsWith('TOP SECRET') || upper.startsWith('TOPSECRET')) {
        return 'TOP SECRET';
    }
    if (upper.startsWith('SECRET')) {
        return 'SECRET';
    }
    if (upper.startsWith('UNCLASSIFIED')) {
        return 'UNCLASSIFIED';
    }
    if (ICR_CLASSIFICATIONS.includes(upper)) {
        return ICR_CLASSIFICATIONS.find((c) => c.toUpperCase() === upper);
    }
    return value;
}

/** Map stored classification to an edit-form option (UNCLASSIFIED, SECRET, TOP SECRET). */
export function normalizeIcrClassificationForEdit(classification) {
    const formatted = formatIcrClassification(classification);
    if (formatted === '—' || !ICR_CLASSIFICATIONS.includes(formatted)) {
        return 'UNCLASSIFIED';
    }
    return formatted;
}

export function isPastDueDate(dueDate) {
    if (!dueDate || !dayjs(dueDate).isValid()) {
        return false;
    }
    return dayjs(dueDate).startOf('day').isBefore(dayjs().startOf('day'));
}

export function formatIcrDueDateDisplay(dueDate) {
    if (!dueDate || !dayjs(dueDate).isValid()) {
        return {label: 'Due date: —', isPast: false};
    }
    const formatted = dayjs(dueDate).format('MMM D, YYYY');
    return {
        label: `Due date: ${formatted}`,
        isPast: isPastDueDate(dueDate),
    };
}
